import { getWebsocketUrl, type ApiParameters } from "@/modules/api/createApiClient.ts";
import invariant from "tiny-invariant";

interface WsUrlParams extends ApiParameters {
    location: string;
    query: string;
    subscribe: boolean;
}

export function getMetricsWsUrl({ apiPrefix, location, apikey, query, subscribe }: WsUrlParams) {
    invariant(apikey, "API key must be set to create a socket");
    const search = new URLSearchParams({ apikey, query, subscribe: subscribe ? "true" : "false" });
    return `${getWebsocketUrl(apiPrefix)}/${location}/metrics-ws/index?${search}`;
}
